module.exports = __webpack_public_path__ + "img/servicio1.00beb3a5.svg";